<template>
    <app-admin-layout :ask-for-quote="askForQuote">
        <Head>
            <title>{{ askForQuote.pfnumber }} - K-Angebot</title>
        </Head>

        <div class="ask-for-quote ask-for-quote--client-offer">

            <ask-for-quote-header :askForQuote="askForQuote"/>

            <div class="ask-for-quote--content">
                <form @submit.prevent="submit" @change="calculateNetPrice">
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <span class="subtitle-1">Angebotspreis kalkulieren</span>
                            </div>
                        </div>
                        <div class="row"  v-if="isGrindaixClient">
                            <div class="col">
                                <card class="warning">
                                    <card-content>
                                        <strong>Margenausnahme aktiv</strong>
                                    </card-content>
                                </card>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-4">
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-content>
                                                <form-group>
                                                    <form-input label="von" placeholder="Deutschland"/>
                                                    <form-input label="nach" placeholder="Deutschland"/>
                                                    <form-button disabled="true">Versandkostenhilfe</form-button>
                                                </form-group>
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-header>
                                                <card-overline>Zeichnung</card-overline>
                                            </card-header>
                                            <card-content>
                                                <sketch-preview :sketchFile="currentSketchFile"/>
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-8">
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-header>
                                                <card-overline>Angebotspreise kalkulieren |
                                                    {{ askForQuote?.client_offers?.[0]?.producer_user?.prod_no }} |
                                                    {{ askForQuote?.client_offers?.[0]?.producer_user?.company }}
                                                </card-overline>
                                            </card-header>
                                            <card-content>
                                                <div class="table--group">
                                                    <table class="table table--card table--stripped">
                                                        <thead>
                                                        <tr>
                                                            <th>&nbsp;</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td>Stückzahl</td>
                                                        </tr>
                                                        <tr>
                                                            <td>P-Preis</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Lieferkosten</td>
                                                        </tr>
                                                        <tr>
                                                            <td>PF-Aufschlag (%)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>PF-Aufschlag (€)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Gesamtpreis (netto)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Stückpreis (netto)</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Umsatzsteuer 19%</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Gesamtpreis</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td>P-Lieferzeit</td>
                                                        </tr>
                                                        <tr>
                                                            <td>K-Lieferzeit</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <table class="table table--card table--stripped"
                                                           v-for="(clientOffer, index) in form.client_offers"
                                                           :key="index">
                                                        <thead>
                                                        <tr>
                                                            <th class="text-right">Losnr. {{ index + 1 }}
                                                                <form-input type="hidden" v-model="clientOffer.id"/>
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td class="text-right">
                                                                {{ this.askForQuote.client_offers[`${index}`].amount }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right">{{
                                                                    this.$currency(this.askForQuote.client_offers[`${index}`].producer_price)
                                                                }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right">
                                                                <form-input v-model="clientOffer.delivery_costs"
                                                                            currency="true"
                                                                            placeholder="Gesamtlieferkosten in €"
                                                                            :error="form.errors[`client_offers.${index}.delivery_costs`]" autocomplete="off"/>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <form-input v-model="clientOffer.partfactory_margin"
                                                                            placeholder="20%"
                                                                            suffix="%"
                                                                            decimal="true"
                                                                            :error="form.errors[`client_offers.${index}.partfactory_margin`]" autocomplete="off"/>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <form-input
                                                                    v-model="clientOffer.partfactory_margin_euro"
                                                                    placeholder="7.75 €"
                                                                    currency="true"
                                                                    @update:modelValue="updateMarginEuro($event, index)" autocomplete="off"/>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right"> {{
                                                                    this.$currency(this.form.client_offers[`${index}`].net_price)
                                                                }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right">{{
                                                                    this.$currency(this.form.client_offers[`${index}`].piece_price)
                                                                }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right">{{
                                                                    this.$currency(this.form.client_offers[`${index}`].price_ust)
                                                                }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right"> {{
                                                                    this.$currency(this.form.client_offers[`${index}`].offer_price)
                                                                }}
                                                                <form-input type="hidden"
                                                                            v-model="clientOffer.offer_price"/>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right">{{
                                                                    this.askForQuote.client_offers[`${index}`].delivery_days_producer
                                                                }} <translate>Tage</translate>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <form-input v-model="clientOffer.delivery_days_client"
                                                                            :error="form.errors[`client_offers.${index}.delivery_days_client`]" autocomplete="off"/>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                                <div class="row row--sticky" v-sticky>
                                    <div class="col">
                                        <form-button color="secondary" class="btn--block" :disabled="clientOfferIsSend || disabledTab || ! hasClientOffers || form.processing" :class="{'btn--processing': form.processing}">Angebot versenden
                                        </form-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </app-admin-layout>
</template>

<script>
import {useForm} from '@inertiajs/vue3';
import AskForQuoteHeader from '@partfactory/Pages/Admin/AskForQuote/Header/AskForQuoteHeader';
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormGroup from '@partfactory/Shared/Form/FormGroup';
import SketchPreview from '@partfactory/Shared/Elements/SketchPreview';

export default {
    name: 'ClientOffer',
    components: {
        SketchPreview,
        FormGroup,
        FormButton,
        FormInput,
        CardContent,
        CardOverline,
        CardHeader,
        Card,
        AppAdminLayout,
        AskForQuoteHeader
    },
    props: {
        askForQuote: Object,
    },
    data() {
        const form = useForm({
            client_offers: [],
        });

        const numericInput = [
            'producer_price',
            'delivery_costs',
            'partfactory_margin',
            'partfactory_margin_euro',
            'net_price',
            'piece_price',
            'price_ust',
            'offer_price',
        ];

        return {form, numericInput};
    },
    computed: {
        currentSketchFile() {
            return this.askForQuote.sketch_files[0];
        },
        clientOfferIsSend() {
            // TODO, sollte auch serverseitig geprüft werden
            const clientOffers = this.askForQuote.client_offers.filter(clientOffer => clientOffer.client_offer_send);
            return clientOffers.length > 0;
        },
        isGrindaixClient() {
            return this.$page.props.factors.margin_exception === this.askForQuote.client_user.client_no;
        },
        hasClientOffers() {
            return this.askForQuote.client_offers.length > 0;
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 6);
        },
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.client-offer.post', {'askForQuote': this.askForQuote.id}), {
                    preserveScroll: false,
                    onSuccess: () => {
                    },
                });
        },
        calculateNetPrice() {
            this.form.client_offers.forEach(clientOffer => {

                Object.keys(clientOffer).forEach(item => {
                    if (this.numericInput.includes(item))
                        clientOffer[item] = parseFloat(clientOffer[item]);
                });

                let delivery_costs = clientOffer.delivery_costs ? clientOffer.delivery_costs : 0;

                // clientOffer.net_price = (1 + (clientOffer.partfactory_margin / 100)) * (clientOffer.producer_price + clientOffer.delivery_costs);
                clientOffer.net_price = (clientOffer.producer_price + delivery_costs) / (100 - clientOffer.partfactory_margin) * 100;
                clientOffer.net_price = (Math.round(clientOffer.net_price * 100) / 100).toFixed(2);
                clientOffer.partfactory_margin_euro = clientOffer.net_price - clientOffer?.producer_price - delivery_costs;
                clientOffer.piece_price = clientOffer.net_price / clientOffer.amount;
                clientOffer.price_ust = clientOffer.net_price * .19;
                clientOffer.offer_price = clientOffer.net_price * 1.19;

                Object.keys(clientOffer).forEach(item => {
                    if (this.numericInput.includes(item)) {
                        clientOffer[item] = parseFloat(clientOffer[item]);
                        const regexp = '/[^0-9,\\.]+/g';
                        const cleaned = clientOffer[item].toString().replace(regexp, '').replace(',', '.');
                        const parsed = parseFloat(cleaned);
                        clientOffer[item] = cleaned != 'NaN' ? (Math.round(parsed * 100) / 100).toFixed(2) : '';
                        // clientOffer[item] = item === 'partfactory_margin' ? clientOffer[item] + ' %' : ' €';
                        // .replace('.',',');
                    }
                });
            });
        },
        updateMarginEuro(value, index) {

            const net = parseFloat(this.form.client_offers[index].producer_price) + parseFloat(this.form.client_offers[index].delivery_costs) + parseFloat(value);

            this.form.client_offers[index].partfactory_margin = (parseFloat(value) / (net / 100)).toFixed(2);
        },
        calculateMargin() {
            this.form.client_offers.forEach((clientOffer, index) => {
                const margin = parseFloat(clientOffer.net_price) - parseFloat(clientOffer.producer_price) - parseFloat(clientOffer.delivery_costs);
                clientOffer.partfactory_margin_euro = margin;
                this.updateMarginEuro(margin, index);
            });
            this.calculateNetPrice();
        }
    },
    mounted() {
        this.askForQuote.client_offers.forEach(clientOffer => {
            this.form.client_offers.push({
                id: clientOffer?.id ? clientOffer?.id : null,
                amount: clientOffer?.amount ? clientOffer?.amount : null,
                producer_price: clientOffer?.producer_price ? clientOffer?.producer_price : null,
                delivery_costs: clientOffer?.delivery_costs !== null ? clientOffer?.delivery_costs : null,
                partfactory_margin: this.isGrindaixClient ? 0 : clientOffer?.partfactory_margin !== null ? clientOffer?.partfactory_margin : this.$page.props.factors.margin_partfactory_default,
                partfactory_margin_euro: null,
                net_price: clientOffer?.net_price ? clientOffer?.net_price : null,
                piece_price: null,
                price_ust: null,
                offer_price: clientOffer?.offer_price ? clientOffer?.offer_price : null,
                delivery_days_client: clientOffer?.delivery_days_client ? clientOffer?.delivery_days_client : clientOffer.delivery_days_producer + this.$page.props.factors.delivery_time_part_client,
                offer_valid_date: clientOffer?.offer_valid_date ? clientOffer?.offer_valid_date : null,
            });
        });

        if (this.askForQuote.client_offers?.[0]?.producer_price && this.askForQuote.client_offers?.[0]?.delivery_costs && this.askForQuote.client_offers?.[0]?.net_price && !this.askForQuote.client_offers?.[0]?.partfactory_margin) {
            this.calculateMargin();
        } else {
            this.calculateNetPrice();
        }


    },
};
</script>
